import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=646104ae"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=646104ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports